import Home from './Home'

export default {
  path: '/',
  exact: true,
  component: Home
}



// WEBPACK FOOTER //
// ./src/routes/home/index.js